<div class="table-responsive">
    <table class="table dt-responsive datatables custom no-footer dtr-inline mb-0" *ngIf="columnData">
    <thead class="table-light">
      <tr>
        <ng-container *ngFor="let c of columnData">
          <th
            *ngIf="!c.hidden && c.sortable"
            class="cursor-pointer"
            [class.sticky-column]="c.stickyColumn"
            [style.width]="c.width"
            [style.min-width]="c.width"
            [style.max-width]="c.width"
            [sortable]="c.key"
            [direction]="sorts?.field === c.key && sorts?.direction && (sorts.direction === 'asc' || sorts.direction === 'desc') ? sorts?.direction : ''"
            (sort)="onSort($event)"
          >
            {{ c.tKey | transloco }}
            <span class="sort-icon"></span>
          </th>

          <th
            *ngIf="!c.hidden &&
            !c.sortable"
            class="not-sort"
            [style.width]="c.width"
            [style.min-width]="c.width"
            [style.max-width]="c.width"
          >
            <input
              *ngIf="c.dataType === 'rowSelect'"
              class="form-check-input cursor-pointer"
              [checked]="isAllRowsSelected"
              (change)="onAllRowsSelect($event, c.isRowSelectable)"
              type="checkbox"
            />
            {{ !!c.tKey ? (c.tKey | transloco) : '' }}
          </th>
        </ng-container>

        <th
          *ngIf="actionList?.length"
          class="not-sort"
          [class.td-fixed-right]="stickyActionListColumn"
        ></th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let row of tableData; let i = index; trackBy: trackByRowId">
        <ng-container *ngFor="let c of columnData">
          <td
            *ngIf="!c.hidden"
            class="column-wrap"
            [class.sticky-column]="c.stickyColumn"
            [class.column-custom-width]="!!c.width"
            [style.width]="c.width"
            [style.min-width]="c.width"
            [style.max-width]="c.width"
          >
            <div
              *ngIf="c.dataType === 'number' || c.dataType ==='string' || c.dataType === 'date'"
              class="{{ c.cellClasslist }}"
              [innerHTML]="(row[c.key] ?? '') ? ((row[c.key] ?? '') | highlight: search) : '—'"
            ></div>

            <div
              *ngIf="c.dataType === 'phone'"
              class="{{ c.cellClasslist }}"
              [innerHTML]="(row[c.key] ?? '') | phoneMask | phoneHighlight:search"
            ></div>

            <div
              *ngIf="c.dataType === 'currency'"
              class="{{ c.cellClasslist }}"
            >{{ row[c.key] | currency: (c.currencyCode || defaultCurrencyCode) : currencyDisplay : currencyDigitsInfo }}</div>

            <div
              *ngIf="c.dataType === 'rowSelect'"
              class="{{ c.cellClasslist }}"
            >
              <input
                class="form-check-input"
                [class.cursor-pointer]="!c.isRowSelectable || c.isRowSelectable(row)"
                type="checkbox"
                [checked]="!!selectionMap.has(row.id)"
                [disabled]="c.isRowSelectable && !c.isRowSelectable(row)"
                [title]="c.isRowSelectable && !c.isRowSelectable(row) && c.disabledSelectTooltip ? (c.disabledSelectTooltip | transloco) : ''"
                (change)="onRowSelect(row, $event)"
              />
            </div>

            <ng-container *ngIf="c.dataType === 'status'">
              <app-grid-cell-status
                *ngIf="row[c.key]"
                [status]="row[c.key]"
                [searchQuery]="search"
                [spinnerStatuses]="c.spinnerStatuses || []"
              ></app-grid-cell-status>
              <span *ngIf="!row[c.key]" class="text-muted">—</span>
            </ng-container>

            <app-table-cell-custom-value
              *ngIf="c.dataType === 'custom' && c.customDataType"
              [dataType]="c.customDataType"
              [dataOptions]="c.customDataOptions ? c.customDataOptions(row) : null"
              [searchQuery]="search"
              [value]="row[c.key]">
            </app-table-cell-custom-value>

            <ng-container *ngIf="c.dataType === 'projectTemplate' && !!c.projectColumnTemplate">
              <ng-container *ngTemplateOutlet="c.projectColumnTemplate; context: { 'item': row }"></ng-container>
            </ng-container>
          </td>
        </ng-container>

        <td *ngIf="actionList?.length" class="column-nowrap column-action td-fixed-right">
          <app-table-cell-actions-menu
            [row]="row"
            [actionList]="actionList"
            (action)="onTableAction($event, row)">
          </app-table-cell-actions-menu>
        </td>
      </tr>
    </tbody>
  </table>

  <app-table-not-found-content *ngIf="!tableData.length && !loading"></app-table-not-found-content>

  <div class="position-absolute row card-bottom card-bottom-mobile bottom-0 start-0">
    <div class="d-sm-flex justify-content-sm-between">
      <ngb-pagination
        [collectionSize]="pagination.total"
        [(page)]="pagination.page"
        [pageSize]="pagination.pageSize"
        [maxSize]="maxPaginationSize"
        [ellipses]="true"
        (pageChange)="onPageChange($event)">
      </ngb-pagination>

      <app-pagination-size
        [pageSize]="pagination.pageSize"
        (clicked)="onPageSizeChange($event)">
      </app-pagination-size>
    </div>
  </div>
</div>
